import { Settings } from '../interfaces/settings';

export const initialState: Settings = {
  board: {
    color_by: false,
  },
  subitems_board: {
    color_by: false,
  },
  // hide_all_items: false,
  // hide_parent_items: false,
  // open_parent_item: false,
  default_view: '',
  slot_duration: '00:30:00',
  first_day: 0,
  grid: false,
  hour12: true,
  work_week: false,
  group_selection: { color: false, title: false },
  legend: false,
  is_collapse_all_day_events: true,
  is_all_day_data: false,
  is_initial_date: false,
  initial_timestamp: 0,
  start_time: '08',
  end_time: '21',
  // initial_date: '',
  // is_event_updates: false,
};
